import React from "react";
import step1 from "../assets/delete ac step 1.png"
import step2 from "../assets/delete ac step 2.png"
import step3 from "../assets/delete ac step 3.png"
import step4 from "../assets/delete ac step 4.png"

const AccountDeletionPage = () => {
  return (
    <div style={{ background: "#ffffff", padding: 20 }}>
      At Echo, we value your privacy and believe in giving you control over your
      data. If you wish to delete your account, follow the steps outlined below.
      Please note that account deletion is permanent and cannot be undone.
      <br />
      <br />
      Deleting your account will remove all your personal data, including:{" "}
      <br /> Profile information <br /> History <br />
      Preferences <br /> We do not retain any personal data of any form after
      your account is deleted. <br />
      <br /> If you experience any issues or have questions, please contact us:{" "}
      <br /> Email:{" "}
      <a href="mailto:support@cognisights.in">support@cognisights.in</a> <br />
      <br /> Step by Step process on how to delete your account on Echo: <br /> <br />
      1. Login to your account on Echo
      <div style={{display: 'flex', justifyContent: 'center', padding: '10px'}}>
        <img src={step1} alt="Account Deletion Step 1" width={200} style={{border: '2px solid #000000'}}/>
      </div>
      2. Navigate to your profile 
      <div style={{display: 'flex', justifyContent: 'center', padding: '10px'}}>
        <img src={step2} alt="Account Deletion Step 2" width={200} style={{border: '2px solid #000000'}}/> 
      </div>
      3. Click on delete account option
      <div style={{display: 'flex', justifyContent: 'center', padding: '10px'}}>
        <img src={step3} alt="Account Deletion Step 3" width={200} style={{border: '2px solid #000000'}}/>
      </div>
      4. Confirm account deletion
      <div style={{display: 'flex', justifyContent: 'center', padding: '10px'}}>
        <img src={step4} alt="Account Deletion Step 4" width={200} style={{border: '2px solid #000000'}}/>
      </div>
    </div>
  );
};

export default AccountDeletionPage;
